import {BasicRoute, PrivateRoute} from '~/components/elements/AppRouter';
import BaseLayout from '~/components/layouts/BaseLayout';
import PrivateLayout from '~/components/layouts/PrivateLayout';
import NotFoundPage from '~/pages/not-found';
import {PAGE_PATHS} from '~/constants';
import Questionnaire1Screen from '~/pages/home/weight-loss-one/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/home/weight-loss-one/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/home/weight-loss-one/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/home/weight-loss-one/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/home/weight-loss-one/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/home/weight-loss-one/Questionnaire6Screen';
import Questionnaire6AScreen from '~/pages/home/weight-loss-one/Questionnaire6AScreen';
import Questionnaire6BScreen from '~/pages/home/weight-loss-one/Questionnaire6BScreen';
import Questionnaire7Screen from '~/pages/home/weight-loss-one/Questionnaire7Screen';
import Questionnaire7AScreen from '~/pages/home/weight-loss-one/Questionnaire7AScreen';
import Questionnaire8Screen from '~/pages/home/weight-loss-one/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/home/weight-loss-one/Questionnaire9Screen';
import Questionnaire10Screen from '~/pages/home/weight-loss-one/Questionnaire10Screen';
import Questionnaire11Screen from '~/pages/home/weight-loss-one/Questionnaire11Screen';
import Questionnaire12Screen from '~/pages/home/weight-loss-one/Questionnaire12Screen';
import Questionnaire7NewScreen from '~/pages/home/weight-loss-one/Questionnaire7NewScreen';
import Questionnaire8GLPScreen from '~/pages/home/weight-loss-one/Questionnaire8GLPScreen';
import Questionnaire8PillScreen from '~/pages/home/weight-loss-one/Questionnaire8PillScreen';
import Questionnaire8CGMScreen from '~/pages/home/weight-loss-one/Questionnaire8CGMScreen';
import QuestionnaireCGMPackageScreen from '~/pages/home/weight-loss-one/QuestionnaireCGMPackageScreen';
import QuestionnaireCGMAddonScreen from '~/pages/home/weight-loss-one/QuestionnaireCGMAddonScreen';
import Questionnaire10GLPScreen from '~/pages/home/weight-loss-one/Questionnaire10GLPScreen';
import Questionnaire10PillScreen from '~/pages/home/weight-loss-one/Questionnaire10PillScreen';
import Questionnaire8SupplementScreen from '~/pages/home/weight-loss-one/Questionnaire8SupplementScreen';
import Questionnaire10SupplementScreen from '~/pages/home/weight-loss-one/Questionnaire10SupplementScreen';
import MDQ2Questionnaire1Screen from '~/pages/home/weight-loss-two/Questionnaire1Screen';
import MDQ2Questionnaire2Screen from '~/pages/home/weight-loss-two/Questionnaire2Screen';
import MDQ2Questionnaire3Screen from '~/pages/home/weight-loss-two/Questionnaire3Screen';
import MDQ2Questionnaire4Screen from '~/pages/home/weight-loss-two/Questionnaire4Screen';
import MDQ2Questionnaire5Screen from '~/pages/home/weight-loss-two/Questionnaire5Screen';
import MDQ2Questionnaire6Screen from '~/pages/home/weight-loss-two/Questionnaire6Screen';
import MDQ2Questionnaire7Screen from '~/pages/home/weight-loss-two/Questionnaire7Screen';
import MDQ2Questionnaire8Screen from '~/pages/home/weight-loss-two/Questionnaire8Screen';
import MDQ2Questionnaire9Screen from '~/pages/home/weight-loss-two/Questionnaire9Screen';
import MDQ2Questionnaire10Screen from '~/pages/home/weight-loss-two/Questionnaire10Screen';
import MDQ2QuestionnaireInvalidScreen from '~/pages/home/weight-loss-two/QuestionnaireInvalidScreen';
import Questionnaire10DoctorScreen from '~/pages/home/weight-loss-one/Questionnaire10DoctorScreen';
import QuestionnaireSaxendaPackageScreen from '~/pages/home/weight-loss-one/QuestionnaireSaxendaPackageScreen';
import Questionnaire11SaxendaScreen from '~/pages/home/weight-loss-one/Questionnaire11SaxendaScreen';
import Questionnaire11NextSaxendaScreen from '~/pages/home/weight-loss-one/Questionnaire11NextSaxendaScreen';
import QuestionnaireRybelsusPackageScreen from '~/pages/home/weight-loss-one/QuestionnaireRybelsusPackageScreen';
import Questionnaire11NextRybelsusScreen from '~/pages/home/weight-loss-one/Questionnaire11NextRybelsusScreen';
import QuestionnairePanbesyPackageScreen from '~/pages/home/weight-loss-one/QuestionnairePanbesyPackageScreen';
import Questionnaire11NextPanbesyScreen from '~/pages/home/weight-loss-one/Questionnaire11NextPanbesyScreen';
import Questionnaire8NutritionScreen from '~/pages/home/weight-loss-one/Questionnaire8NutritionScreen';
import Questionnaire9NutritionScreen from '~/pages/home/weight-loss-one/Questionnaire9NutritionScreen';
import QuestionnaireNutritionPackageScreen from '~/pages/home/weight-loss-one/QuestionnaireNutritionPackageScreen';
import Questionnaire11NutritionScreen from '~/pages/home/weight-loss-one/Questionnaire11NutritionScreen';
import QuestionnaireNutritionDeliveryScreen from '~/pages/home/weight-loss-one/QuestionnaireNutritionDeliveryScreen';
import Questionnaire13NutritionScreen from '~/pages/home/weight-loss-one/Questionnaire13NutritionScreen';
import MDQRenewalQuestionnaire1Screen from '~/pages/home/weight-loss-renewal/Questionnaire1Screen';
import MDQRenewalQuestionnaire2Screen from '~/pages/home/weight-loss-renewal/Questionnaire2Screen';
import MDQRenewalQuestionnaire3Screen from '~/pages/home/weight-loss-renewal/Questionnaire3Screen';
import MDQRenewalQuestionnaire4Screen from '~/pages/home/weight-loss-renewal/Questionnaire4Screen';
import MDQRenewalQuestionnaire5Screen from '~/pages/home/weight-loss-renewal/Questionnaire5Screen';
import MDQRenewalQuestionnaireInvalidScreen from '~/pages/home/weight-loss-renewal/QuestionnaireInvalidScreen';

export const publicRoutes: BasicRoute[] = [
  {
    path: '/',
    component: BaseLayout,
    exact: false,
    routes: [
      {path: '/', exact: true, redirect: PAGE_PATHS.MDQ_1},
      {
        path: PAGE_PATHS.MDQ_1,
        exact: false,
        routes: [
          {path: '/', component: Questionnaire1Screen},
          {
            path: PAGE_PATHS.MDQ_1_2,
            component: Questionnaire2Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_3,
            component: Questionnaire3Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_4,
            component: Questionnaire4Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_5,
            component: Questionnaire5Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_6,
            component: Questionnaire6Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_6A,
            component: Questionnaire6AScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_6B,
            component: Questionnaire6BScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_7NEW,
            component: Questionnaire7NewScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_7,
            component: Questionnaire7Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_7A,
            component: Questionnaire7AScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_8,
            component: Questionnaire8Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_8_GLP,
            component: Questionnaire8GLPScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_8_PILL,
            component: Questionnaire8PillScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_8_CGM,
            component: Questionnaire8CGMScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_8_SUPPLEMENTS,
            component: Questionnaire8SupplementScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_8_NUTRITION,
            component: Questionnaire8NutritionScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_9,
            component: Questionnaire9Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_9_NUTRITION,
            component: Questionnaire9NutritionScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10,
            component: Questionnaire10Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_DOCTOR,
            component: Questionnaire10DoctorScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_GLP,
            component: Questionnaire10GLPScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_PILL,
            component: Questionnaire10PillScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_SUPPLEMENTS,
            component: Questionnaire10SupplementScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_CGM,
            component: QuestionnaireCGMPackageScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_SAXENDA,
            component: QuestionnaireSaxendaPackageScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_RYBELSUS,
            component: QuestionnaireRybelsusPackageScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_PANBESY,
            component: QuestionnairePanbesyPackageScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_10_NUTRITION,
            component: QuestionnaireNutritionPackageScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_11_GCM,
            component: QuestionnaireCGMAddonScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_11_SAXENDA,
            component: Questionnaire11SaxendaScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_11_NEXT_SAXENDA,
            component: Questionnaire11NextSaxendaScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_11_NEXT_RYBELSUS,
            component: Questionnaire11NextRybelsusScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_11_NEXT_PANBESY,
            component: Questionnaire11NextPanbesyScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_11_NUTRITION,
            component: Questionnaire11NutritionScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_11,
            component: Questionnaire11Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_12,
            component: Questionnaire12Screen,
          },
          {
            path: PAGE_PATHS.MDQ_1_12_NUTRITION,
            component: QuestionnaireNutritionDeliveryScreen,
          },
          {
            path: PAGE_PATHS.MDQ_1_13_NUTRITION,
            component: Questionnaire13NutritionScreen,
          },
          {path: '/*', component: NotFoundPage},
        ],
      },
      {
        path: PAGE_PATHS.MDQ_2,
        exact: false,
        routes: [
          {path: '/', component: MDQ2Questionnaire1Screen},
          {path: PAGE_PATHS.MDQ_2_2, component: MDQ2Questionnaire2Screen},
          {path: PAGE_PATHS.MDQ_2_3, component: MDQ2Questionnaire3Screen},
          {path: PAGE_PATHS.MDQ_2_4, component: MDQ2Questionnaire4Screen},
          {path: PAGE_PATHS.MDQ_2_5, component: MDQ2Questionnaire5Screen},
          {path: PAGE_PATHS.MDQ_2_6, component: MDQ2Questionnaire6Screen},
          {path: PAGE_PATHS.MDQ_2_7, component: MDQ2Questionnaire7Screen},
          {path: PAGE_PATHS.MDQ_2_8, component: MDQ2Questionnaire8Screen},
          {path: PAGE_PATHS.MDQ_2_9, component: MDQ2Questionnaire9Screen},
          {path: PAGE_PATHS.MDQ_2_10, component: MDQ2Questionnaire10Screen},
          {path: PAGE_PATHS.MDQ_2_INVALID, component: MDQ2QuestionnaireInvalidScreen},
        ],
      },
      {
        path: PAGE_PATHS.MDQ_RENEWAL,
        exact: false,
        routes: [
          {path: '/', component: MDQRenewalQuestionnaire1Screen},
          {path: PAGE_PATHS.MDQ_RENEWAL_2, component: MDQRenewalQuestionnaire2Screen},
          {path: PAGE_PATHS.MDQ_RENEWAL_3, component: MDQRenewalQuestionnaire3Screen},
          {path: PAGE_PATHS.MDQ_RENEWAL_4, component: MDQRenewalQuestionnaire4Screen},
          {path: PAGE_PATHS.MDQ_RENEWAL_5, component: MDQRenewalQuestionnaire5Screen},
          {path: PAGE_PATHS.MDQ_RENEWAL_INVALID, component: MDQRenewalQuestionnaireInvalidScreen},
          {path: '/*', component: MDQRenewalQuestionnaireInvalidScreen},
        ],
      },
      {path: '/*', component: NotFoundPage},
    ],
  },
];

export const privateRoutes: PrivateRoute[] = [
  {
    path: '/p',
    component: PrivateLayout,
    exact: false,
    routes: [{path: '/*', component: NotFoundPage}],
  },
];
